import ValidationPopup from './ValidationPopup';

export default ValidationPopup;
